// import 'react-app-polyfill/ie11';
// import "@babel/polyfill";
import './polyfill.js';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import initConfig from './initConfig.js';
import configureStore from './store/storeConfig';
import { printHeader } from './utils/helpers.js';

export const initialState = window.initialReduxState; // Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(initialState); //Setup the global store object

initConfig('production', 'repcaststudio');
document.title = "REPCast Studio";
printHeader();

const elements = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

ReactDOM.render(elements, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
